var _defaultIconTypes, _tagTextStyles, _Shape$Rectangle, _Shape$Pill, _shapePadding, _sizeStyles;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Shape } from '@doordash/design-language';
import { IconTypes, TagSizes, TagTypes } from './types/TagTypes';
export var defaultIconTypes = (_defaultIconTypes = {}, _defineProperty(_defaultIconTypes, TagTypes.HighlightDefault, IconTypes.PromoLine), _defineProperty(_defaultIconTypes, TagTypes.HighlightEmphasis, IconTypes.PromoLine), _defineProperty(_defaultIconTypes, TagTypes.HighlightSubdued, IconTypes.PromoLine), _defineProperty(_defaultIconTypes, TagTypes.InformationalDefault, IconTypes.InfoLine), _defineProperty(_defaultIconTypes, TagTypes.InformationalEmphasis, IconTypes.InfoLine), _defineProperty(_defaultIconTypes, TagTypes.InformationalSubdued, IconTypes.InfoLine), _defineProperty(_defaultIconTypes, TagTypes.NegativeDefault, IconTypes.ErrorFill), _defineProperty(_defaultIconTypes, TagTypes.NegativeEmphasis, IconTypes.ErrorFill), _defineProperty(_defaultIconTypes, TagTypes.NegativeSubdued, IconTypes.ErrorFill), _defineProperty(_defaultIconTypes, TagTypes.PositiveDefault, IconTypes.CheckCircleLine), _defineProperty(_defaultIconTypes, TagTypes.PositiveEmphasis, IconTypes.CheckCircleLine), _defineProperty(_defaultIconTypes, TagTypes.PositiveSubdued, IconTypes.CheckCircleLine), _defineProperty(_defaultIconTypes, TagTypes.WarningDefault, IconTypes.WarningFill), _defineProperty(_defaultIconTypes, TagTypes.WarningEmphasis, IconTypes.WarningFill), _defineProperty(_defaultIconTypes, TagTypes.WarningSubdued, IconTypes.WarningFill), _defaultIconTypes);
export var tagTextStyles = (_tagTextStyles = {}, _defineProperty(_tagTextStyles, TagSizes.XSmall, 'TagXSmallLabel'), _defineProperty(_tagTextStyles, TagSizes.Small, 'TagSmallLabel'), _defineProperty(_tagTextStyles, TagSizes.Medium, 'TagMediumLabel'), _defineProperty(_tagTextStyles, TagSizes.Large, 'TagLargeLabel'), _tagTextStyles);
export var shapePadding = (_shapePadding = {}, _defineProperty(_shapePadding, Shape.Rectangle, (_Shape$Rectangle = {}, _defineProperty(_Shape$Rectangle, TagSizes.XSmall, {
  horizontal: 4,
  horizontalWithIcon: 4,
  vertical: 3,
  verticalWithIcon: 3
}), _defineProperty(_Shape$Rectangle, TagSizes.Small, {
  horizontal: 4,
  horizontalWithIcon: 4,
  vertical: 3,
  verticalWithIcon: 4
}), _defineProperty(_Shape$Rectangle, TagSizes.Medium, {
  horizontal: 6,
  horizontalWithIcon: 6,
  vertical: 3,
  verticalWithIcon: 3
}), _defineProperty(_Shape$Rectangle, TagSizes.Large, {
  horizontal: 8,
  horizontalWithIcon: 8,
  vertical: 7,
  verticalWithIcon: 4
}), _Shape$Rectangle)), _defineProperty(_shapePadding, Shape.Pill, (_Shape$Pill = {}, _defineProperty(_Shape$Pill, TagSizes.XSmall, {
  horizontal: 6,
  horizontalWithIcon: 4,
  vertical: 3,
  verticalWithIcon: 3
}), _defineProperty(_Shape$Pill, TagSizes.Small, {
  horizontal: 8,
  horizontalWithIcon: 4,
  vertical: 3,
  verticalWithIcon: 2
}), _defineProperty(_Shape$Pill, TagSizes.Medium, {
  horizontal: 10,
  horizontalWithIcon: 6,
  vertical: 3,
  verticalWithIcon: 3
}), _defineProperty(_Shape$Pill, TagSizes.Large, {
  horizontal: 12,
  horizontalWithIcon: 8,
  vertical: 7,
  verticalWithIcon: 4
}), _Shape$Pill)), _shapePadding);
export var sizeStyles = (_sizeStyles = {}, _defineProperty(_sizeStyles, TagSizes.XSmall, {
  iconSize: 12,
  inlineChildrenSize: 'XxxxSmall'
}), _defineProperty(_sizeStyles, TagSizes.Small, {
  iconSize: 16,
  inlineChildrenSize: 'XxxxSmall'
}), _defineProperty(_sizeStyles, TagSizes.Medium, {
  iconSize: 16,
  inlineChildrenSize: 'XxxxSmall'
}), _defineProperty(_sizeStyles, TagSizes.Large, {
  iconSize: 24,
  inlineChildrenSize: 'XxxSmall'
}), _sizeStyles);